// extracted by mini-css-extract-plugin
export var subtitle = "_bh-2";
export var title = "_bh-0";
export var titleNoWrap = "_bh-1";